import { Select } from "components/Form/Select";
import { useFormContext } from "react-hook-form";
import { InputGroup } from "styles/InputGroup";

type RemoveResponsibleProps = {
  hasResponsible: boolean;
}

export function RemoveResponsible({ hasResponsible }: RemoveResponsibleProps) {
  const { control } = useFormContext();

  return (
    <InputGroup flexItem>
      <Select
        name="remove_responsible"
        control={control}
        id="remove_responsible"
        label="Remov. responsável?"
        placeholder="Selecione"
        fullwidth
        config={{
          noOptionsMessage: () => 'Sem opções.',
          options: [
            { value: true, label: 'Sim' },
            { value: false, label: 'Não' },
          ],
          closeMenuOnSelect: true,
        }}
        disabled={!hasResponsible}
      >
        <option value="false">Não</option>
        <option value="true">Sim</option>
      </Select>
    </InputGroup>
  );
}
